<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="title">请选择行业</div>
          <div class="inpBox">
            <!-- <div class="iconfont icon-search search dis-cent"></div>
            <div class="box">
              <input type="text" placeholder="请输入名称搜索" />
            </div> -->
          </div>
          <div class="youBox">
            <div class="iconfont icon-close close" @click="gbClick"></div>
          </div>
        </div>
        <div class="cont">
          <div class="contRig">
            <div class="nrCont">
              <div
                class="text dis-cent"
                :class="tradeOn == item.id ? 'on' : ''"
                v-for="(item, index) in trade"
                @click="contClick(item)"
              >
                {{ item.c_name }}
              </div>
            </div>
            <div class="diCont">
              <div class="name">已选: {{ tradeTxt }}</div>
              <div class="btn dis-cent" @click="gbClick">确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      contOn: null,
      trade: [],
      xzList: [],
      tradeOn: 0,
      tradeTxt: "",
    };
  },
  props: ["ldData"],
  created() {
    console.log(this.ldData);
    
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
    if (this.ldData.tradeOn) {
      this.tradeOn = this.ldData.tradeOn
      this.tradeTxt = this.ldData.tradeTxt
    }
    if (this.ldData.length>=1) {
      this.tradeOn = this.ldData[0].tradeOn
      this.tradeTxt = this.ldData[0].tradeTxt
    }
    console.log(this.tradeOn);
  },
  methods: {
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 所属行业
      let trade = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_trade") {
          trade.push(e);
        }
      }
      this.trade = trade;
    },
    gbClick() {
      this.$emit("show", { tradeOn: this.tradeOn, tradeTxt: this.tradeTxt });
    },
    contClick(item) {
      this.tradeOn = item.id;
      this.tradeTxt = item.c_name;
    },
    mrGet() {
      
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 850px;
  height: 600px;
  .headBox {
    height: 70px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .title {
      font-weight: 600;
      font-size: 18px;
      width: 220px;
    }
    .inpBox {
      width: 250px;
      height: 30px;
      border-radius: 5px;
      // background-color: #f0f0f0;
      display: flex;
      .search {
        height: 30px;
        width: 40px;
        font-weight: 600;
        color: #9c9c9c;
        font-size: 18px;
      }
      .box {
        width: calc(100% - 40px);
        height: 30px;
        position: relative;
        left: -4px;
        input {
          width: 100%;
          height: 100%;
        }
      }
    }
    .youBox {
      width: 380px;
      display: flex;
      justify-content: flex-end;
      .close {
        font-weight: 600;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  .cont {
    display: flex;
    height: calc(100% - 70px);
    .contLeft {
      width: 210px;
      border-right: 1px solid #ebebeb;
      box-sizing: border-box;
      overflow: auto;
      height: 100%;
      padding: 15px;
      .text {
        padding: 0 10px;
        height: 35px;
        border-radius: 5px;
        margin-bottom: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .name {
          width: calc(100% - 20px);
        }
        .num {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: #fff;
          background: #147ee0;
          font-size: 12px;
        }
      }
      .on {
        background-color: #e6ecf7;
        font-weight: 600;
        color: #147ee0;
      }
      .text:hover {
        background-color: #e6ecf7;
        color: #147ee0;
        font-weight: 600;
      }
    }
    .contRig {
      width: 100%;
      overflow: hidden;
      position: relative;
      .nrCont {
        padding: 20px;
        height: calc(100% - 80px);
        box-sizing: border-box;
        width: 100%;
        overflow: auto;
        .text {
          float: left;
          margin-bottom: 15px;
          padding: 0 13px;
          height: 30px;
          border-radius: 5px;
          background-color: #eef1f5;
          border: 1px solid #eef1f5;
          color: #000;
          margin-right: 15px;
          cursor: pointer;
          box-sizing: border-box;
        }
        .text:hover {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
        .on {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
      }
      .diCont {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          width: 200px;
        }
        .btn {
          width: 80px;
          height: 38px;
          border-radius: 38px;
          background-color: #147ee0;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
